import { lazy } from "react";

// Distinct from `analyticsRoutes`, which mounts the MERCHANT analytics page at
// `store/:storeId/analytics`. Same word, different surface and a different
// payload from the same paths — see entities/analytics/model/systemTypes.ts.
const SystemAnalyticsPage = lazy(
  () => import("@/widgets/system-admin/analytics/SystemAnalyticsPage"),
);

const SystemAnalyticsRoutes = {
  path: "analytics",
  children: [{ index: true, element: <SystemAnalyticsPage /> }],
};

export default SystemAnalyticsRoutes;
